const posts = [
  {
    date: "Jan 15",
    category: "Blog",
    title: "From CNC Machine Operator to Full Stack Developer",
    excerpt:
      "For years I programmed CNC machines — writing G-code, managing tolerances down to hundredths of a millimetre, and debugging why a part came out wrong. I never imagined that discipline would become the foundation of my programming career. Both fields demand the same mindset: precision, logical thinking, and the patience to trace a bug back to its root cause. When I wrote my first JavaScript function, the feeling was the same as setting up a perfect machining operation — a system that just works, every time. This is the story of that transition, and why I believe manufacturing is the best hidden school for software engineering.",
    readTime: "5 min read",
  },
  {
    date: "Mar 08",
    category: "Blog",
    title: "React vs Vue: Lessons from Using Both in Production",
    excerpt:
      "After building the Vartig company site in Vue.js and my other projects in React, I have a nuanced take on this debate. Both are excellent, but they reward different thinking styles.",
    readTime: "4 min read",
  },
  {
    date: "Apr 22",
    category: "Blog",
    title: "Why Every Full Stack Project Starts with the Database Schema",
    excerpt:
      "Before writing a single line of frontend code, I spend time designing the MongoDB schema. A poorly designed schema will cost you ten times more later. Here's my process.",
    readTime: "3 min read",
  },
];

const stats = [
  { value: "3+",  label: "Years Coding"       },
  { value: "6+",  label: "Projects Delivered" },
  { value: "2",   label: "Languages Used"     },
  { value: "100%", label: "Custom Built"      },
];

const BlogSection = () => (
  <section id="blog" className="bg-[#131523] py-24 px-6 md:px-12 lg:px-20">
    <div className="max-w-7xl mx-auto">

      {/* Stats bar */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20 pb-16 border-b border-[#1e2030]">
        {stats.map(({ value, label }) => (
          <div key={label} className="text-center md:text-left">
            <p className="font-IBM font-bold text-4xl md:text-5xl text-white mb-1">{value}</p>
            <p className="font-IBM text-sm text-gray-500">{label}</p>
          </div>
        ))}
      </div>

      {/* Blog header + list */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

        {/* Left: intro */}
        <div>
          <p className="text-[#f5c210] text-xs tracking-[0.2em] uppercase font-IBM mb-4">— Blog</p>
          <h2 className="font-IBM font-bold text-white text-4xl md:text-5xl leading-tight mb-6">
            Thoughts &<br />Latest News.
          </h2>
          <p className="text-gray-400 font-IBM text-sm leading-relaxed max-w-sm">
            Writing about web development, my journey from manufacturing to code, and the lessons that carry over between both worlds.
          </p>
        </div>

        {/* Right: post list */}
        <div className="flex flex-col divide-y divide-[#1e2030]">
          {posts.map((post) => (
            <div
              key={post.title}
              className="group py-6 first:pt-0 cursor-pointer"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <p className="font-IBM text-xs text-gray-600 mb-2 tracking-wide">
                    {post.date} · {post.category} · {post.readTime}
                  </p>
                  <h3 className="font-IBM font-semibold text-white text-base group-hover:text-[#f5c210] transition-colors leading-snug mb-2">
                    {post.title}
                  </h3>
                  <p className="font-IBM text-gray-500 text-xs leading-relaxed line-clamp-3">
                    {post.excerpt}
                  </p>
                </div>
                <span className="text-gray-600 group-hover:text-[#f5c210] group-hover:translate-x-1 transition-all text-xl mt-1 flex-shrink-0">
                  →
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default BlogSection;
